// Dismissible "new training available" banner for the Learning Center library. Shows the most
// recently gone-live in-scope module until the user dismisses it (remembered per rooftop) or it
// ages out. See useNewContentAlert for the go-live / dismissal logic.

import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button, Stack } from '@mui/material';
import { useNewContentAlert } from '../hooks/useNewContentAlert';
import type { ModuleSummary } from '../types';

export default function NewContentAlert({ modules }: { modules: ModuleSummary[] }) {
  const { alertModule, dismiss } = useNewContentAlert(modules);
  if (!alertModule) return null;

  return (
    <Alert
      severity="info"
      sx={{ mb: 3 }}
      action={
        <Stack direction="row" spacing={1}>
          <Button
            color="inherit"
            size="small"
            component={RouterLink}
            to={`/learning-center/${encodeURIComponent(alertModule.key)}`}
            onClick={dismiss}
          >
            View
          </Button>
          <Button color="inherit" size="small" onClick={dismiss}>
            Dismiss
          </Button>
        </Stack>
      }
    >
      New training available: <strong>{alertModule.name}</strong>
    </Alert>
  );
}
